import { Modal, ModalOverlay, ModalContent, ModalBody, ModalFooter, Button, ModalCloseButton, Text, Flex } from '@chakra-ui/react'
import { MdsErrorRound } from 'react-icons-with-materialsymbols/mds'

interface ErrorModalProps {
  isOpen: boolean
  onClose: () => void
  onRefresh: () => void
  error: string | null
}

export const ErrorModal = ({ isOpen, onClose, onRefresh, error }: ErrorModalProps): JSX.Element => (
  <Modal isCentered isOpen={isOpen} onClose={onClose}>
    <ModalOverlay />
    <ModalContent className="!max-w-440 !pb-0 !gap-y-0.5">
      <Flex className="relative px-5">
        <Flex className="!font-normal !text-lg !text-red-600" align="center" gap={2}>
          <MdsErrorRound className="stroke-[22]" size={20} />
          Dashboard Error
        </Flex>
        <ModalCloseButton className="!mr-0 !-top-1" />
      </Flex>
      <ModalBody className="!px-5 !pb-4 !py-0 text-sm w-fit leading-[21px] text-gray-800">
        <Flex className="flex-col text-sm leading-[140%] text-gray-800 gap-3">
          <Text>{error}</Text>
          <Text>To resolve this issue:</Text>
          <Text className="pl-4">1. Try refreshing the page</Text>
          <Text className="pl-4">2. Ensure you have a stable internet connection</Text>
          <Text className="pl-4">3. If the issue persists, please contact Clootrack Support</Text>
        </Flex>
      </ModalBody>
      <ModalFooter>
        <Flex className="flex-row !p-6 w-full justify-center">
          <Button
            colorScheme="secondary"
            onClick={onRefresh}
            size="sm"
            variant="solid"
          >
            Refresh Dashboard
          </Button>
        </Flex>
      </ModalFooter>
    </ModalContent>
  </Modal>
) 